import { render, staticRenderFns } from "./FullscreenIframe.vue?vue&type=template&id=75cfa6d2"
import script from "./FullscreenIframe.vue?vue&type=script&setup=true&lang=js"
export * from "./FullscreenIframe.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FullscreenIframe.vue?vue&type=style&index=0&id=75cfa6d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports